/* eslint-disable react/jsx-pascal-case */

import React, { useEffect, useState } from 'react';
import Layout from '../../Layout';
import SectiononePP from '.././Sectionone';
import Contact_us from '../../Home/ContactUs';
import AllSectionone from '../../ReusableComp/Sectionone';
import * as Images from '../../../assets';
import ContactUs from '../../GetInTouch/ContactUs';
import GoldenLedgerContent from './GoldenLedgerContent';

const PlanPricing = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);

    useEffect(() => {
        window.scroll(0, 0);
    }, [])
    return (
        <>
            <Layout
                isModalOpen={isModalOpen}
                isSuccessModalOpen={isSuccessModalOpen}
                isFailedModalOpen={isFailedModalOpen}
            >
                {/* <SectiononePP/> */}
                <AllSectionone
                    src={Images.plna_pricing_bg_new}
                    title={'The Golden Ledger Program'}
                    link_to2={'/'}
                    link_name2={'Our Products'}
                    link_to3={'/golden_ledger_program_details'}
                    link_name3={'The Golden Ledger Program'}
                />
                <GoldenLedgerContent />
                <Contact_us />
                {/* <ContactUs/> */}
            </Layout>
        </>
    )
}

export default PlanPricing